/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { EdrCloudInstance } from '../model/edrCloudInstance';
// @ts-ignore
import { EdrCloudInstancePatchSpec } from '../model/edrCloudInstancePatchSpec';
// @ts-ignore
import { EdrCloudInstanceSpec } from '../model/edrCloudInstanceSpec';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { MigratedRwrDeploymentSummary } from '../model/migratedRwrDeploymentSummary';
// @ts-ignore
import { OperatorRwrActivationDetails } from '../model/operatorRwrActivationDetails';
// @ts-ignore
import { OperatorRwrDeploymentDetails } from '../model/operatorRwrDeploymentDetails';
// @ts-ignore
import { PaginatedOperatorRwrActivationDetails } from '../model/paginatedOperatorRwrActivationDetails';
// @ts-ignore
import { RansomwareRecoveryActivationSpec } from '../model/ransomwareRecoveryActivationSpec';
// @ts-ignore
import { RansomwareRecoveryDeactivationSpec } from '../model/ransomwareRecoveryDeactivationSpec';
// @ts-ignore
import { RwrDeploymentPatchRequest } from '../model/rwrDeploymentPatchRequest';
// @ts-ignore
import { TaskV2 } from '../model/taskV2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class RansomwareRecoveryOperatorV2Service extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Activate Ransomware Recovery with different supported EDRs
     * Activate Ransomware Recovery on given Org and Region
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param ransomwareRecoveryActivationSpec Ransomware Recovery Activation spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public activateEdrRansomwareRecoveryOperator(edrVendor: 'cs' | 'cb', ransomwareRecoveryActivationSpec: RansomwareRecoveryActivationSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public activateEdrRansomwareRecoveryOperator(edrVendor: 'cs' | 'cb', ransomwareRecoveryActivationSpec: RansomwareRecoveryActivationSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public activateEdrRansomwareRecoveryOperator(edrVendor: 'cs' | 'cb', ransomwareRecoveryActivationSpec: RansomwareRecoveryActivationSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public activateEdrRansomwareRecoveryOperator(edrVendor: 'cs' | 'cb', ransomwareRecoveryActivationSpec: RansomwareRecoveryActivationSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling activateEdrRansomwareRecoveryOperator.');
        }
        if (ransomwareRecoveryActivationSpec === null || ransomwareRecoveryActivationSpec === undefined) {
            throw new Error('Required parameter ransomwareRecoveryActivationSpec was null or undefined when calling activateEdrRansomwareRecoveryOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/deployments`;
        return this.httpClient.request<TaskV2>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: ransomwareRecoveryActivationSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a EDR cloud instance.
     * Create a EDR cloud instance.
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrCloudInstanceSpec Request to create a EDR cloud instance.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createEdrCloudInstance(edrVendor: 'cs' | 'cb', edrCloudInstanceSpec: EdrCloudInstanceSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EdrCloudInstance>;
    public createEdrCloudInstance(edrVendor: 'cs' | 'cb', edrCloudInstanceSpec: EdrCloudInstanceSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EdrCloudInstance>>;
    public createEdrCloudInstance(edrVendor: 'cs' | 'cb', edrCloudInstanceSpec: EdrCloudInstanceSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EdrCloudInstance>>;
    public createEdrCloudInstance(edrVendor: 'cs' | 'cb', edrCloudInstanceSpec: EdrCloudInstanceSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling createEdrCloudInstance.');
        }
        if (edrCloudInstanceSpec === null || edrCloudInstanceSpec === undefined) {
            throw new Error('Required parameter edrCloudInstanceSpec was null or undefined when calling createEdrCloudInstance.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/cloud-instances`;
        return this.httpClient.request<EdrCloudInstance>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: edrCloudInstanceSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deactivate ransomware recovery deployment with different supported EDRs
     * Deactivate ransomware recovery deployment
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param ransomwareRecoveryDeactivationSpec Deactivation spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deactivateRansomwareRecoveryDeploymentOperator(edrVendor: 'cs' | 'cb', ransomwareRecoveryDeactivationSpec: RansomwareRecoveryDeactivationSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public deactivateRansomwareRecoveryDeploymentOperator(edrVendor: 'cs' | 'cb', ransomwareRecoveryDeactivationSpec: RansomwareRecoveryDeactivationSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public deactivateRansomwareRecoveryDeploymentOperator(edrVendor: 'cs' | 'cb', ransomwareRecoveryDeactivationSpec: RansomwareRecoveryDeactivationSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public deactivateRansomwareRecoveryDeploymentOperator(edrVendor: 'cs' | 'cb', ransomwareRecoveryDeactivationSpec: RansomwareRecoveryDeactivationSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling deactivateRansomwareRecoveryDeploymentOperator.');
        }
        if (ransomwareRecoveryDeactivationSpec === null || ransomwareRecoveryDeactivationSpec === undefined) {
            throw new Error('Required parameter ransomwareRecoveryDeactivationSpec was null or undefined when calling deactivateRansomwareRecoveryDeploymentOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/deployments`;
        return this.httpClient.request<TaskV2>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: ransomwareRecoveryDeactivationSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete EDR cloud instance.
     * Delete EDR cloud instance.
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrRegionId EDR cloud instance region.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEdrCloudInstance(edrVendor: 'cs' | 'cb', edrRegionId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteEdrCloudInstance(edrVendor: 'cs' | 'cb', edrRegionId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteEdrCloudInstance(edrVendor: 'cs' | 'cb', edrRegionId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteEdrCloudInstance(edrVendor: 'cs' | 'cb', edrRegionId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling deleteEdrCloudInstance.');
        }
        if (edrRegionId === null || edrRegionId === undefined) {
            throw new Error('Required parameter edrRegionId was null or undefined when calling deleteEdrCloudInstance.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/cloud-instances/${this.configuration.encodeParam({name: "edrRegionId", value: edrRegionId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get EDR cloud instances configured.
     * Get EDR cloud instances configured.
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrRegionId Filter the mapping using EDR cloud instance region.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public filterEdrCloudInstances(edrVendor: 'cs' | 'cb', edrRegionId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<EdrCloudInstance>>;
    public filterEdrCloudInstances(edrVendor: 'cs' | 'cb', edrRegionId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<EdrCloudInstance>>>;
    public filterEdrCloudInstances(edrVendor: 'cs' | 'cb', edrRegionId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<EdrCloudInstance>>>;
    public filterEdrCloudInstances(edrVendor: 'cs' | 'cb', edrRegionId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling filterEdrCloudInstances.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>edrRegionId, 'edr-region-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/cloud-instances`;
        return this.httpClient.request<Array<EdrCloudInstance>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Ransomware Recovery Deployment By ID.
     * Get Ransomware Recovery Deployment By ID.
     * @param deploymentId Deployment identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOperatorRansomwareRecoveryDeployment(deploymentId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OperatorRwrActivationDetails>;
    public getOperatorRansomwareRecoveryDeployment(deploymentId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OperatorRwrActivationDetails>>;
    public getOperatorRansomwareRecoveryDeployment(deploymentId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OperatorRwrActivationDetails>>;
    public getOperatorRansomwareRecoveryDeployment(deploymentId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling getOperatorRansomwareRecoveryDeployment.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<OperatorRwrActivationDetails>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Ransomware Recovery activation details for an operator.
     * Get Ransomware Recovery activation details for an operator.
     * @param orgId organization identifier
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param provider Cloud provider
     * @param regionId AWS + GCP RegionId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOperatorRwrDeploymentDetails(orgId: string, edrVendor: 'cs' | 'cb', provider?: 'AWS' | 'GCP', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2' | 'us-west1' | 'us-west2' | 'us-west3' | 'us-west4' | 'us-east1' | 'us-east4' | 'us-east5' | 'us-central1' | 'us-south1' | 'europe-west2' | 'europe-west3' | 'europe-west4' | 'europe-west6' | 'europe-west8' | 'europe-west9' | 'europe-west12' | 'asia-southeast1' | 'us' | 'europe' | 'asia-northeast1' | 'asia-south1' | 'asia-south2' | 'australia-southeast1' | 'me-west1' | 'northamerica-northeast1' | 'northamerica-northeast2' | 'southamerica-east1' | 'southamerica-west1', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OperatorRwrDeploymentDetails>;
    public getOperatorRwrDeploymentDetails(orgId: string, edrVendor: 'cs' | 'cb', provider?: 'AWS' | 'GCP', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2' | 'us-west1' | 'us-west2' | 'us-west3' | 'us-west4' | 'us-east1' | 'us-east4' | 'us-east5' | 'us-central1' | 'us-south1' | 'europe-west2' | 'europe-west3' | 'europe-west4' | 'europe-west6' | 'europe-west8' | 'europe-west9' | 'europe-west12' | 'asia-southeast1' | 'us' | 'europe' | 'asia-northeast1' | 'asia-south1' | 'asia-south2' | 'australia-southeast1' | 'me-west1' | 'northamerica-northeast1' | 'northamerica-northeast2' | 'southamerica-east1' | 'southamerica-west1', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OperatorRwrDeploymentDetails>>;
    public getOperatorRwrDeploymentDetails(orgId: string, edrVendor: 'cs' | 'cb', provider?: 'AWS' | 'GCP', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2' | 'us-west1' | 'us-west2' | 'us-west3' | 'us-west4' | 'us-east1' | 'us-east4' | 'us-east5' | 'us-central1' | 'us-south1' | 'europe-west2' | 'europe-west3' | 'europe-west4' | 'europe-west6' | 'europe-west8' | 'europe-west9' | 'europe-west12' | 'asia-southeast1' | 'us' | 'europe' | 'asia-northeast1' | 'asia-south1' | 'asia-south2' | 'australia-southeast1' | 'me-west1' | 'northamerica-northeast1' | 'northamerica-northeast2' | 'southamerica-east1' | 'southamerica-west1', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OperatorRwrDeploymentDetails>>;
    public getOperatorRwrDeploymentDetails(orgId: string, edrVendor: 'cs' | 'cb', provider?: 'AWS' | 'GCP', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2' | 'us-west1' | 'us-west2' | 'us-west3' | 'us-west4' | 'us-east1' | 'us-east4' | 'us-east5' | 'us-central1' | 'us-south1' | 'europe-west2' | 'europe-west3' | 'europe-west4' | 'europe-west6' | 'europe-west8' | 'europe-west9' | 'europe-west12' | 'asia-southeast1' | 'us' | 'europe' | 'asia-northeast1' | 'asia-south1' | 'asia-south2' | 'australia-southeast1' | 'me-west1' | 'northamerica-northeast1' | 'northamerica-northeast2' | 'southamerica-east1' | 'southamerica-west1', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getOperatorRwrDeploymentDetails.');
        }
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling getOperatorRwrDeploymentDetails.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>provider, 'provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>regionId, 'region-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/deployments/deployment`;
        return this.httpClient.request<OperatorRwrDeploymentDetails>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch a EDR cloud instance.
     * Patch a EDR cloud instance.
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrRegionId EDR cloud instance region.
     * @param edrCloudInstancePatchSpec Request to update a EDR cloud instance.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchEdrCloudInstance(edrVendor: 'cs' | 'cb', edrRegionId: string, edrCloudInstancePatchSpec: EdrCloudInstancePatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EdrCloudInstance>;
    public patchEdrCloudInstance(edrVendor: 'cs' | 'cb', edrRegionId: string, edrCloudInstancePatchSpec: EdrCloudInstancePatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EdrCloudInstance>>;
    public patchEdrCloudInstance(edrVendor: 'cs' | 'cb', edrRegionId: string, edrCloudInstancePatchSpec: EdrCloudInstancePatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EdrCloudInstance>>;
    public patchEdrCloudInstance(edrVendor: 'cs' | 'cb', edrRegionId: string, edrCloudInstancePatchSpec: EdrCloudInstancePatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling patchEdrCloudInstance.');
        }
        if (edrRegionId === null || edrRegionId === undefined) {
            throw new Error('Required parameter edrRegionId was null or undefined when calling patchEdrCloudInstance.');
        }
        if (edrCloudInstancePatchSpec === null || edrCloudInstancePatchSpec === undefined) {
            throw new Error('Required parameter edrCloudInstancePatchSpec was null or undefined when calling patchEdrCloudInstance.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/cloud-instances/${this.configuration.encodeParam({name: "edrRegionId", value: edrRegionId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<EdrCloudInstance>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: edrCloudInstancePatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Query Ransomware Recovery Deployments.
     * Query Ransomware Recovery Deployments.
     * @param edrVendor Filter by EDR vendor EDR vendor.
     * @param orgId organization identifier in optional filter
     * @param regionId AWS + GCP RegionId
     * @param edrRegionId Filter the mapping using EDR cloud instance region.
     * @param edrOrgId Filter the mapping using EDR org id.
     * @param state Ransomware Recovery Deployment Activation State
     * @param provider Cloud provider
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryOperatorRansomwareRecoveryDeployments(edrVendor?: 'CARBON_BLACK' | 'CROWDSTRIKE', orgId?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2' | 'us-west1' | 'us-west2' | 'us-west3' | 'us-west4' | 'us-east1' | 'us-east4' | 'us-east5' | 'us-central1' | 'us-south1' | 'europe-west2' | 'europe-west3' | 'europe-west4' | 'europe-west6' | 'europe-west8' | 'europe-west9' | 'europe-west12' | 'asia-southeast1' | 'us' | 'europe' | 'asia-northeast1' | 'asia-south1' | 'asia-south2' | 'australia-southeast1' | 'me-west1' | 'northamerica-northeast1' | 'northamerica-northeast2' | 'southamerica-east1' | 'southamerica-west1', edrRegionId?: string, edrOrgId?: string, state?: 'REQUESTED' | 'IN_PROGRESS' | 'ACTIVE' | 'INACTIVE' | 'FAILED' | 'DEACTIVATION_PENDING_APPROVAL', provider?: 'AWS' | 'GCP', pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<PaginatedOperatorRwrActivationDetails>;
    public queryOperatorRansomwareRecoveryDeployments(edrVendor?: 'CARBON_BLACK' | 'CROWDSTRIKE', orgId?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2' | 'us-west1' | 'us-west2' | 'us-west3' | 'us-west4' | 'us-east1' | 'us-east4' | 'us-east5' | 'us-central1' | 'us-south1' | 'europe-west2' | 'europe-west3' | 'europe-west4' | 'europe-west6' | 'europe-west8' | 'europe-west9' | 'europe-west12' | 'asia-southeast1' | 'us' | 'europe' | 'asia-northeast1' | 'asia-south1' | 'asia-south2' | 'australia-southeast1' | 'me-west1' | 'northamerica-northeast1' | 'northamerica-northeast2' | 'southamerica-east1' | 'southamerica-west1', edrRegionId?: string, edrOrgId?: string, state?: 'REQUESTED' | 'IN_PROGRESS' | 'ACTIVE' | 'INACTIVE' | 'FAILED' | 'DEACTIVATION_PENDING_APPROVAL', provider?: 'AWS' | 'GCP', pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PaginatedOperatorRwrActivationDetails>>;
    public queryOperatorRansomwareRecoveryDeployments(edrVendor?: 'CARBON_BLACK' | 'CROWDSTRIKE', orgId?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2' | 'us-west1' | 'us-west2' | 'us-west3' | 'us-west4' | 'us-east1' | 'us-east4' | 'us-east5' | 'us-central1' | 'us-south1' | 'europe-west2' | 'europe-west3' | 'europe-west4' | 'europe-west6' | 'europe-west8' | 'europe-west9' | 'europe-west12' | 'asia-southeast1' | 'us' | 'europe' | 'asia-northeast1' | 'asia-south1' | 'asia-south2' | 'australia-southeast1' | 'me-west1' | 'northamerica-northeast1' | 'northamerica-northeast2' | 'southamerica-east1' | 'southamerica-west1', edrRegionId?: string, edrOrgId?: string, state?: 'REQUESTED' | 'IN_PROGRESS' | 'ACTIVE' | 'INACTIVE' | 'FAILED' | 'DEACTIVATION_PENDING_APPROVAL', provider?: 'AWS' | 'GCP', pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PaginatedOperatorRwrActivationDetails>>;
    public queryOperatorRansomwareRecoveryDeployments(edrVendor?: 'CARBON_BLACK' | 'CROWDSTRIKE', orgId?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2' | 'us-west1' | 'us-west2' | 'us-west3' | 'us-west4' | 'us-east1' | 'us-east4' | 'us-east5' | 'us-central1' | 'us-south1' | 'europe-west2' | 'europe-west3' | 'europe-west4' | 'europe-west6' | 'europe-west8' | 'europe-west9' | 'europe-west12' | 'asia-southeast1' | 'us' | 'europe' | 'asia-northeast1' | 'asia-south1' | 'asia-south2' | 'australia-southeast1' | 'me-west1' | 'northamerica-northeast1' | 'northamerica-northeast2' | 'southamerica-east1' | 'southamerica-west1', edrRegionId?: string, edrOrgId?: string, state?: 'REQUESTED' | 'IN_PROGRESS' | 'ACTIVE' | 'INACTIVE' | 'FAILED' | 'DEACTIVATION_PENDING_APPROVAL', provider?: 'AWS' | 'GCP', pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>edrVendor, 'edr-vendor');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>regionId, 'region-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>edrRegionId, 'edr-region-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>edrOrgId, 'edr-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>state, 'state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>provider, 'provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/deployments`;
        return this.httpClient.request<PaginatedOperatorRwrActivationDetails>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set the EDR region for BYOL RWR deployments
     * Sets the EDR region column value for BYOL RWR deployments by looking up the API endpoint and matching it against the cloud instance table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateEdrRegionForRwrByolDeploymentsOperator(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<MigratedRwrDeploymentSummary>;
    public updateEdrRegionForRwrByolDeploymentsOperator(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MigratedRwrDeploymentSummary>>;
    public updateEdrRegionForRwrByolDeploymentsOperator(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MigratedRwrDeploymentSummary>>;
    public updateEdrRegionForRwrByolDeploymentsOperator(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/deployments/migrate`;
        return this.httpClient.request<MigratedRwrDeploymentSummary>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set the EDR region for RWR deployments
     * Update the RWR deployment\&#39;s selected fields
     * @param deploymentId Deployment identifier
     * @param rwrDeploymentPatchRequest Ransomware Recovery Update spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateOperatorRansomwareRecoveryDeployment(deploymentId: string, rwrDeploymentPatchRequest: RwrDeploymentPatchRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OperatorRwrActivationDetails>;
    public updateOperatorRansomwareRecoveryDeployment(deploymentId: string, rwrDeploymentPatchRequest: RwrDeploymentPatchRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OperatorRwrActivationDetails>>;
    public updateOperatorRansomwareRecoveryDeployment(deploymentId: string, rwrDeploymentPatchRequest: RwrDeploymentPatchRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OperatorRwrActivationDetails>>;
    public updateOperatorRansomwareRecoveryDeployment(deploymentId: string, rwrDeploymentPatchRequest: RwrDeploymentPatchRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling updateOperatorRansomwareRecoveryDeployment.');
        }
        if (rwrDeploymentPatchRequest === null || rwrDeploymentPatchRequest === undefined) {
            throw new Error('Required parameter rwrDeploymentPatchRequest was null or undefined when calling updateOperatorRansomwareRecoveryDeployment.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<OperatorRwrActivationDetails>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rwrDeploymentPatchRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
